import SodFooter from './SodFooter';

export default SodFooter;
